import { jsx as _jsx } from "react/jsx-runtime";
var Facebook = function Facebook(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: 0.4375 * size,
    height: size,
    viewBox: "0 0 14 32",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      d: "M14.418 10.361h-4.91V7.04c0-1.248.801-1.539 1.365-1.539h3.465V.018L9.565-.001c-5.298 0-6.503 4.089-6.503 6.708v3.655H0v5.65h3.063V32h6.445V16.012h4.347z"
    })
  });
};
export default Facebook;